export const ExternalLink = ({
  to,
  children,
  className,
  ...props
}: {
  to: string;
  children: any;
  className: string;
}) => (
  <a
    href={to}
    {...props}
    className={className}
    target="_blank"
    rel="noreferrer"
  >
    {children}
  </a>
);
